import { validateServerData } from '@wwt/core/admin'
import { DislikedOfferIdsListDto } from '@wwt/entities/api/search-response'

import { api } from '@/shared/api/client'

export const dislikesQuery = async (signal: AbortSignal) => {
	const response = await api()
		.options({ signal })
		.get('/v1/offers/dislikes')
		.json()

	return await validateServerData(response, DislikedOfferIdsListDto, 'Dislikes')
}
